module.exports = __webpack_public_path__ + "img/主营业务_系统节能改造02.fc273499.png";